import * as TaskRunner from 'util/TaskRunner';

export function exportSessions(params: {
  appId: string;
  exportFormat: string;
  startTime?: string;
  endTime?: string;
  sessionName?: string;
  sessionStatuses?: Array<string>;
}): JQueryPromise<{url: string}> {
  return TaskRunner.postJSON({
    url: `/1/api/benchling-app-sessions:export`,
    data: params,
  });
}
